var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBidet = function SvgBidet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bidet_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M17.5 17.5H13a2.5 2.5 0 0 0-2.45 2h6.95z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M17.5 17.5H12A4.5 4.5 0 0 1 7.5 13v-1.5h10zM6 9.5h11.5V11a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5ZM17.5 3v6a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5 1a3 3 0 0 1 3 3v2.5a.5.5 0 0 1-1 0V4a2 2 0 1 0-4 0v.5a.5.5 0 0 1-1 0V4a3 3 0 0 1 3-3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 1a3 3 0 0 0-3 3v2.5a.5.5 0 0 0 1 0V4a2 2 0 1 1 4 0v.5a.5.5 0 0 0 1 0V4a3 3 0 0 0-3-3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bidet_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgBidet;